interface KpiCardProps {
  label: string;
  value: string;
  subLabel?: string;
  accent?: "default" | "emerald" | "blue" | "amber" | "cyan" | "rose";
}

export function KpiCard({ label, value, subLabel, accent = "default" }: KpiCardProps) {
  const accentClass =
    accent === "emerald"
      ? "border-emerald-800/60"
      : accent === "blue"
        ? "border-blue-800/60"
        : accent === "amber"
          ? "border-amber-800/60"
          : accent === "cyan"
            ? "border-cyan-800/60"
            : accent === "rose"
              ? "border-rose-800/60"
              : "border-ink-700";

  return (
    <div
      className={`rounded-lg border bg-ink-850 px-5 py-4 ${accentClass}`}
      role="region"
      aria-label={label}
    >
      <p className="text-xs font-medium text-ink-400">{label}</p>
      <p className="mt-2 break-words text-2xl font-semibold tabular-nums text-ink-100">{value}</p>
      {subLabel && <p className="mt-1 text-xs text-ink-500">{subLabel}</p>}
    </div>
  );
}
